function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
import Icon from '../../atoms/Icon';
import Text from '../../atoms/Text';
var StyledIconLabel = styled.div(_templateObject());

var IconLabel = function IconLabel(_ref) {
  var referenceClass = _ref.referenceClass,
      iconLabel = _ref.iconLabel,
      iconWidth = _ref.iconWidth,
      iconHeight = _ref.iconHeight,
      icon = _ref.icon,
      text = _ref.text,
      textVariant = _ref.textVariant,
      fontSize = _ref.fontSize,
      textClass = _ref.textClass,
      iconClass = _ref.iconClass,
      rest = _objectWithoutPropertiesLoose(_ref, ["referenceClass", "iconLabel", "iconWidth", "iconHeight", "icon", "text", "textVariant", "fontSize", "textClass", "iconClass"]);

  return /*#__PURE__*/React.createElement(StyledIconLabel, _extends({
    className: referenceClass
  }, rest), /*#__PURE__*/React.createElement(Icon, {
    path: icon,
    label: iconLabel,
    width: iconWidth,
    height: iconHeight,
    referenceClass: iconClass
  }), /*#__PURE__*/React.createElement(Text, {
    text: text,
    variant: textVariant,
    size: fontSize,
    referenceClass: textClass
  }));
};

IconLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  referenceClass: PropTypes.string,
  iconLabel: PropTypes.string,
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  textVariant: PropTypes.string,
  fontSize: PropTypes.string,
  textClass: PropTypes.string,
  iconClass: PropTypes.string
} : {};
IconLabel.defaultProps = {
  referenceClass: '',
  iconLabel: '',
  iconWidth: '20',
  iconHeight: '20',
  textVariant: 'primary',
  fontSize: 'regular',
  textClass: '',
  iconClass: '',
  theme: defaultTheme
};
export default IconLabel;